import React, {
  createContext,
  //useCallback,
  //useEffect,
  //useMemo,
  //useRef,
  //useState,
} from "react";
import Map, {
  GeolocateControl,
  Layer,
  Marker,
  NavigationControl,
  Source,
} from "react-map-gl";
import maplibregl from "maplibre-gl";
import { feature } from "topojson-client";
import SearchBar from "./SearchBar";
//import { ViewSelector } from "./ViewSelector";
import { Tooltip } from "./Tooltip";
//import { ntaToolTip } from "./Tooltip";
import { Legend } from "./Legend";
import { NtaLegend } from "./Legend";
import { CircularProgress } from "@mui/material";
import { Attribution } from "./Attribution";
import classnames from "classnames";
import { Overlay } from "./Overlay";
//import { ArticleDetail } from "./ArticleDetail";
import { logAmplitudeEventWithData } from "./Amplitude";
import { use100vh } from "react-div-100vh";
//import { isMobile } from "./Overlay";
import {
  getClickStyle,
  getHoverStyle,
  //getLineStyle,
  getFillStyle,
  getLowOpacityFillStyle,
  //getLowOpacityFillStyleLine,
  getPointStyle,
  //getPopupStyle,
  MAPBOX_STYLE_URL,
  MAPBOX_TOKEN,
  transformStyleRequest,
} from "./MapStyles";
//import { useSearchParams } from "react-router-dom";

import "maplibre-gl/dist/maplibre-gl.css";

export const MapContext = createContext({
  mapData: null,
  visibleViewType: "",
  setVisibleViewType: () => {},
  isInteractingWithMap: false,
  setInteractingWithMap: () => {},
});

export const OutboundLink = ({ to, children, className, referrer }) => (
  <a
    className={className}
    href={to}
    target="_blank"
    rel="noopener noreferrer"
    onClick={() =>
      logAmplitudeEventWithData("clickOutboundLink", {
        url: to,
        referrer: referrer || "none",
      })
    }
  >
    {children}
  </a>
);

const BLANK_Article = "";
const BLANK_HoverPoint = "";

const CoordinatesMap = () => {
  const [mapData, setMapData] = React.useState(null);
  const [ntaData, setNtaData] = React.useState(null);
  const [ntaOnlyData, setNtaOnlyData] = React.useState(null);
  const [isInteractingWithMap, setInteractingWithMap] = React.useState(false);
  const [hoverPoint, setHoverPoint] = React.useState(BLANK_HoverPoint);
  const [hoverInfo, setHoverInfo] = React.useState(null);
  const [hoverLat, setHoverLat] = React.useState(null);
  const [hoverLong, setHoverLong] = React.useState(null);
  const [selectedArticle, setSelectedArticle] = React.useState(BLANK_Article);
  const [ntaName, setNtaName] = React.useState(null);
  // const [ntaGeometry, setNtaGeometry] = React.useState(null);
  // const [selectedAddress, setSelectedAddress] = React.useState(null);
  const [selectedRegion, setSelectedRegion] = React.useState(null);
  //const [showPopup, setShowPopup] = React.useState(false);
  const [marker, setMarker] = React.useState([]);
  const [referrer, setReferrer] = React.useState("none");
  const [visibleViewType, setVisibleViewType] = React.useState("ON");

  //const [searchParams, setSearchParams] = useSearchParams();

  const mapRef = React.useRef();

  //const popupStyle = getPopupStyle(showPopup);

  //Define a hidden anchor element in your JSX
  //const anchorRef = React.useRef(null);

  const zoomToPoint = (coords) => {
    if (coords.length === 2) {
      mapRef.current.fitBounds([coords, coords], {
        padding: 1000,
        duration: 4000,
      });
    }
  };

  const onSearchResult = (coords, address) => {
    //setSearchParams({});
    //setSelectedAddress({ a: address });
    setMarker(coords);
    zoomToPoint(coords);
    logAmplitudeEventWithData("searchAddress", {
      a: address,
      referrer: referrer,
    });
  };

  React.useEffect(() => {
    fetch("./data/master_c_2.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((resp) => resp.json())
      .then((json) => {
        setMapData(feature(json, json.objects.master_c_2));
        ////console.log("Coordinates data loaded");
      })
      .catch((err) => console.error("Could not load map data", err));

    fetch("./data/master_n_6.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((resp) => resp.json())
      .then((json) => {
        setNtaData(feature(json, json.objects.master_n_6));
        console.log("Neighborhoods data loaded");
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
      });

    fetch("./data/ntas.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((resp) => resp.json())
      .then((json) => {
        setNtaOnlyData(feature(json, json.objects.ntas));
        //console.log("Neighborhood Tabulation Area data loaded");
      });
  }, []); // eslint-disable-line

  const onHover = React.useCallback((event) => {
    const hoveredFeature = event.features && event.features[0];
    if (!!hoveredFeature && hoveredFeature.geometry.type === "Polygon") {
      setNtaName(hoveredFeature.properties.N);
      // setNtaGeometry(hoveredFeature.geometry.coordinates);
    }
    if (!!hoveredFeature && hoveredFeature.geometry.type === "MultiPolygon") {
      setNtaName(hoveredFeature.properties.N);
      // setNtaGeometry(hoveredFeature.geometry.coordinates);
    }
    if (!!hoveredFeature && hoveredFeature.geometry.type === "Point") {
      if (
        !!hoveredFeature &&
        hoveredFeature.properties &&
        hoveredFeature.properties.URL
      ) {
        setHoverPoint(hoveredFeature.properties.URL);
        setSelectedArticle(hoveredFeature.properties.URL);
      } else {
        //setHoverPoint(null);
        setSelectedArticle(BLANK_Article);
      }
      if (!!hoveredFeature && hoveredFeature.properties.T) {
        setHoverInfo(hoveredFeature.properties.T);
      } else {
        setHoverInfo(null);
      }
      if (
        !!hoveredFeature &&
        hoveredFeature.geometry &&
        hoveredFeature.geometry.coordinates
      ) {
        setHoverLat(hoveredFeature.geometry.coordinates[1]);
      } else {
        setHoverLat(null);
      }
      if (
        !!hoveredFeature &&
        hoveredFeature.geometry &&
        hoveredFeature.geometry.coordinates
      ) {
        setHoverLong(hoveredFeature.geometry.coordinates[0]);
      } else {
        setHoverLong(null);
      }
    }
  }, []);

  //console.log("Hovered Geometry: ", ntaGeometry);
  //console.log("Hovered Latitude 2: ", hoverLat);
  //console.log("Hovered Title is: ", hoverInfo);

  const handleRedirect = (url) => {
    window.open(url, "_blank");
    window.focus();
  };

  const onClick = React.useCallback(
    (event) => {
      setInteractingWithMap(true);
      const article = event.features && event.features[0];
      //console.log("Article on click is: ", article);
      if (
        !!article &&
        !!article.geometry &&
        !!article.geometry.type &&
        article.geometry.type === "Polygon"
      ) {
        setNtaName(article.properties.N);
        setSelectedRegion(filteredData(article.properties.N, ntaData));
        setSelectedArticle(null);
      } else if (
        !!article &&
        !!article.geometry &&
        !!article.geometry.type &&
        article.geometry.type === "MultiPolygon"
      ) {
        setNtaName(article.properties.N);
        setSelectedRegion(filteredData(article.properties.N, ntaData));
        setSelectedArticle(null);
      } else if (
        !!article &&
        !!article.geometry &&
        !!article.geometry.type &&
        article.geometry.type === "Point" &&
        article.properties &&
        article.properties.URL
      ) {
        setSelectedArticle(article.properties.URL);
        handleRedirect(article.properties.URL);
        logAmplitudeEventWithData("clickOnPoint", {
          referrer: setReferrer(referrer),
          ...article.properties,
        });
      } else {
        setSelectedArticle(null);
      }
    },
    [ntaData, referrer]
  ); // eslint-disable-line

  const hoverFilter = React.useMemo(
    () => ["in", "URL", hoverPoint ? hoverPoint : ""],
    [hoverPoint]
    //() => ["in", ""]
  );

  const clickFilter = React.useMemo(
    () => [
      "in",
      "URL",
      selectedArticle && selectedArticle ? selectedArticle : "",
    ],
    [selectedArticle]
  );

  const filteredData = (ntaName, ntaData) => {
    if (!!ntaData && !!ntaName) {
      //const filteredArray = [];
      //console.log(ntaData);
      for (const key in ntaData) {
        //console.log("here inside");
        if (
          key === "features" &&
          typeof ntaData[key] === "object" &&
          ntaData[key] !== null
        ) {
          const dataObject = ntaData[key];
          const filteredData = dataObject.filter(
            (item) => item.properties.N === ntaName
          );
          const sortedDataByPY = filteredData.sort(
            (a, b) => b.properties.PY - a.properties.PY
          );
          // Slice the array to get the top five elements,
          const topFiveDataByPY = sortedDataByPY.slice(0, 5);
          // Extract the 'T' values from the top five elements
          const topFiveTAndURLValues = topFiveDataByPY.map((item) => ({
            N: ntaName,
            C: item.properties.C,
            Title: item.properties.Title,
            U: item.properties.U,
            T: item.properties.T,
          }));

          //console.log("TOP 5 VALS: ", topFiveTAndURLValues);
          return topFiveTAndURLValues;
        }
      }
      //console.log("FA: ", filteredArray);
      //return filteredArray;
    } else {
      console.error("ntaData is not in the expected format");
      return [];
    }
  };

  const onMouseLeave = React.useCallback(() => {
    setSelectedArticle(null);
    setHoverPoint(null);
    setHoverInfo(null);
    setHoverLat(null);
    setHoverLong(null);
    //setNtaName(null);
  }, []);

  const viewportHeight = use100vh();

  return (
    <MapContext.Provider
      value={{
        mapData,
        visibleViewType,
        setVisibleViewType,
        isInteractingWithMap,
        setInteractingWithMap,
      }}
    >
      <div className={classnames("app", isInteractingWithMap && "is-active")}>
        {!!visibleViewType.includes("OFF") && (
          <Overlay selectedArticle={selectedArticle} referrer={referrer} />
        )}
        {!!visibleViewType.includes("ON") && (
          <Overlay selectedArticle={selectedRegion} referrer={referrer} />
        )}

        {!!mapData ? (
          <Map
            ref={mapRef}
            mapLib={maplibregl}
            initialViewState={{
              longitude: -73.977708344928,
              latitude: 40.713323256573386,
              zoom: 10,
            }}
            style={{
              width: "100%",
              height: viewportHeight,
              // This fixes an issue where Chrome/Safari bottom nav overlaps with map content on iPhones.
              // See https://allthingssmitty.com/2020/05/11/css-fix-for-100vh-in-mobile-webkit/
              maxHeight: "-webkit-fill-available",
            }}
            mapStyle={MAPBOX_STYLE_URL}
            transformRequest={transformStyleRequest}
            onMouseMove={onHover}
            onClick={onClick}
            scrollZoom={false}
            dragRotate={false}
            onMouseLeave={onMouseLeave}
            interactiveLayerIds={[
              visibleViewType.includes("OFF") ? "buildings" : "nta-filled",
            ]}
            cursor="pointer"
            minZoom={9}
            maxZoom={18}
            onZoom={() => setInteractingWithMap(true)}
            mapboxAccessToken={MAPBOX_TOKEN}
            attributionControl={false}
          >
            {!!ntaData && !!visibleViewType.includes("ON") && (
              <>
                <Source id="ntas-boundaries" type="geojson" data={ntaData}>
                  <Layer {...getFillStyle()} />
                  <NtaLegend />
                  <Layer
                    id="nta-line"
                    source="ntas-boundaries"
                    type="line"
                    paint={{
                      "line-color": "#fdbe2b",
                      "line-width": [
                        "case",
                        ["==", ["get", "N"], ntaName || ""],
                        5,
                        0.1,
                      ],
                      "line-opacity": [
                        "case",
                        ["==", ["get", "N"], ntaName || ""],
                        1,
                        0.1,
                      ],
                    }}
                  />
                </Source>
              </>
            )}

            {!!visibleViewType.includes("OFF") && (
              <>
                <Source
                  id="ntas-boundaries-2"
                  type="geojson"
                  data={ntaOnlyData}
                >
                  {/*<Layer {...getLowOpacityFillStyleLine()} />*/}
                  <Layer {...getLowOpacityFillStyle()} />
                  {/* <Layer {...getClickStyle()} /> */}
                </Source>
                <Legend is2018Map={false} />
                <Source id="coordinates-data" type="geojson" data={mapData}>
                  <Layer {...getPointStyle()} />
                  <Layer {...getHoverStyle()} filter={hoverFilter} />
                  <Layer {...getClickStyle()} filter={clickFilter} />

                  {!!marker && marker.length === 2 && (
                    <Marker
                      longitude={marker[0]}
                      latitude={marker[1]}
                      color="#8c8c8c"
                    />
                  )}
                </Source>
              </>
            )}

            <GeolocateControl onGeolocate={() => setInteractingWithMap(true)} />
            <NavigationControl showCompass={false} />
            <SearchBar
              onSearchResult={onSearchResult}
              mapboxAccessToken={MAPBOX_TOKEN}
              onClear={() => {
                setMarker([]);
              }}
              position="top-left"
            />
            <Attribution />

            {!!visibleViewType.includes("OFF") && (
              <Tooltip
                hoverInfo={hoverInfo}
                hoverLat={hoverLat}
                hoverLong={hoverLong}
              />
            )}
          </Map>
        ) : (
          <div className="loading-screen">
            <div>
              <CircularProgress color="inherit" />
              <p>Loading...</p>
            </div>
          </div>
        )}
      </div>
    </MapContext.Provider>
  );
};

export default CoordinatesMap;
